function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { styled } from '@goodrx/matisse-react';
import { CdnImage } from '../../../../components/CdnImage';
import { getDataAttributes } from '@goodrx/x-core';
const PressImageStyled = styled(CdnImage)`
  max-height: 48px;
  max-width: 100%;
`;
export const PressImage = /*#__PURE__*/forwardRef(({
  attributes,
  className,
  sys: {
    id
  },
  displayTitle,
  image,
  url
}, linkRef) => /*#__PURE__*/React.createElement("a", _extends({
  className: className,
  key: id,
  href: url || undefined,
  target: "_blank ",
  rel: "noopener noreferrer",
  "aria-label": `As seen on ${displayTitle}`,
  ref: linkRef
}, getDataAttributes(attributes)), image && /*#__PURE__*/React.createElement(PressImageStyled, {
  key: id,
  src: image.url,
  alt: image.title,
  minWidth: 10,
  minHeight: 10
})));